import { useState } from 'react'
import Date from '../../../../Core/Fields/Floating/Date';
import Input from '../../../../Core/Fields/Floating/Input';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import { useGetCountryListQuery } from '../../../../store/api/companyapi'
import { useGetTaxcategoryQuery } from '../../../../store/api/customer'

const Tab1 = ({ formdata, handleChange, setFormData ,apidata }) => {
        const stateOptions =[
        { "name": "Andhra Pradesh" },
        { "name": "Arunachal Pradesh" },
        { "name": "Assam" },
        { "name": "Bihar" },
        { "name": "Chhattisgarh" },
        { "name": "Goa" },
        { "name": "Gujarat" },
        { "name": "Haryana" },
        { "name": "Himachal Pradesh" },
        { "name": "Jharkhand" },
        { "name": "Karnataka" },
        { "name": "Kerala" },
        { "name": "Madhya Pradesh" },
        { "name": "Maharashtra" },
        { "name": "Manipur" },
        { "name": "Meghalaya" },
        { "name": "Mizoram" },
        { "name": "Nagaland" },
        { "name": "Odisha" },
        { "name": "Punjab" },
        { "name": "Rajasthan" },
        { "name": "Sikkim" },
        { "name": "Tamil Nadu" },
        { "name": "Telangana" },
        { "name": "Tripura" },
        { "name": "Uttar Pradesh" },
        { "name": "Uttarakhand" },
        { "name": "West Bengal" },
        { "name": "Andaman and Nicobar Islands" },
        { "name": "Chandigarh" },
        { "name": "Dadra and Nagar Haveli and Daman and Diu" },
        { "name": "Delhi" },
        { "name": "Jammu and Kashmir" },
        { "name": "Ladakh" },
        { "name": "Lakshadweep" },
        { "name": "Puducherry" }
    ]

    const addrsstype = [{ "name": "Billing" }, { "name": "Shipping" }, { "name": "Office" }, { "name": "Personal" }, { "name": "Plant" }, { "name": "Postal" }, { "name": "Shop" }, { "name": "Subssidiary" }, { "name": "Warehouse" }, { "name": "Current" }, { "name": "Permananent" }, { "name": "Other" }]

    const [selectedCompany, setSelectedCompany] = useState('')
    const [isGroup, setIsGroup] = useState(0)
    const { data: countrydata, isLoading: countryLoader } = useGetCountryListQuery();
    const { data: taxcatData, taerror, taisLoading } = useGetTaxcategoryQuery()

    return (
        <div
            className="row "
            style={{ border: "1px solid #00000059", borderRadius: "5px" }}
        >
            <div className="col-12">
                <p className="boxLabel m-0"> Address Details</p>
            </div>

            <div>
                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                name="addressTitle"
                                value={apidata.name}
                                readOnly
                                onChange={handleChange}
                                
                                label="Address Title"
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                              <Input
                                name="addressTitle"
                                value={apidata.address_type}
                                readOnly
                                onChange={handleChange}
                                
                                label="Customer Type"
                                style={{ height: "30px" }}
                            />
                        
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                name="AddressLine1"
                                value={apidata.address_line1}
                                label="Address Line1"
                                readOnly
                                onChange={handleChange}
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                name="AddressLine2"
                                readOnly
                                value={apidata.address_line2}
                                label="Address Line2"
                                onChange={handleChange}
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div>


                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                              <Input
                                name="addressTitle"
                                value={apidata.country}
                                readOnly
                                onChange={handleChange}
                                
                                label="County"
                                style={{ height: "30px" }}
                            />                        
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                              <Input
                                name="addressTitle"
                                value={apidata.state}
                                readOnly
                                onChange={handleChange}
                                
                                label="State/Province"
                                style={{ height: "30px" }}
                            />
                         
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                name='City'
                                readOnly
                                label="City/Town"
                                value={apidata.city}
                                onChange={handleChange}
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                name='postalCode'
                                readOnly
                                label="Postal Code"
                                value={apidata.pincode}
                                onChange={handleChange}
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                label="Email Address"
                                readOnly
                                name='email'
                                value={apidata.email_id}
                                onChange={handleChange}
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                label="Phone"
                                readOnly
                                name='Phone'
                                value={apidata.phone}
                                onChange={handleChange}
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                            readOnly
                                name='Fax'
                                label="Fax"
                                value={apidata.fax}
                                onChange={handleChange}
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                              <Input
                                name="addressTitle"
                                 value={apidata.tax_category}
                                readOnly
                                onChange={handleChange}
                                
                                label="Tax Category"
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='d-flex mx-3 mt-2 mb-3' style={{ gap: '160px', fontSize: '10px', color: '#00000099' }}>
                <div>
                    <input
                        type="checkbox"
                        name='pba'
                        label=''
                        style={{ width: '10px', height: '10px' }}
                        checked={apidata.is_primary_address===1}
                        onChange={handleChange}
                    />
                    <label htmlFor="defaultCheck" style={{ marginLeft: '0.5rem' }}>Preferred Billing Address</label>
                </div>
                <div className='mx-3'>
                    <input
                        type="checkbox"
                        style={{ width: '10px', height: '10px' }}
                        name='psa'
                        checked={apidata.is_shipping_address === 1 }
                        onChange={handleChange}
                    />
                    <label htmlFor="defaultCheck" style={{ marginLeft: '0.5rem' }}>Preferred Shipping Address</label>
                </div><div>
                    <input
                        type="checkbox"
                        style={{ width: '10px', height: '10px' }}
                        name='Disabled'
                        value={formdata.Disabled}
                        checked={apidata.disabled===1}
                        onChange={handleChange}
                    />
                    <label htmlFor="defaultCheck" style={{ marginLeft: '0.5rem' }}>Disabled</label>
                </div>
            </div>

        </div>
    )
}

export default Tab1